import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { TextField } from "@mui/material";

import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";

export default function ServicesCards({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      heading: "",
      description: "",
      btnText: "",
      btnLink: "",
      cards: [
        {
          title: "",
          subTitle: "",
          link: "",
        },
        {
          title: "",
          subTitle: "",
          link: "",
        },
        {
          title: "",
          subTitle: "",
          link: "",
        },
        {
          title: "",
          subTitle: "",
          link: "",
        },
      ],
      language: item.attributes.language,
    }));
    setData(docs);
    let errorDocs = [];
    langs.map(() => {
      errorDocs.push({ error: false });
    });
    setErrors(errorDocs);

    async function getData() {
      await fetch(`${API}/services-section`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.data || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                heading: apiItem.heading || localItem.heading,
                description: apiItem.description || localItem.description,
                btnText: apiItem.btnText || localItem.btnText,
                btnLink: apiItem.btnLink || localItem.btnLink,
                cards: apiItem.cards || localItem.cards,
              };
            } else {
              return localItem;
            }
          });
        });
        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    fetch(`${API}/services-section`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { data: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  return (
    <TabContext value={value}>
      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Services Cards Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs">
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 20,
                    }}>
                    <TextField
                      sx={{ width: 400 }}
                      label="Heading"
                      variant="outlined"
                      value={data[index]?.heading || ""}
                      error={errors[index]?.error}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, heading: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                   
                    <TextEditor
                      value={data[index]?.description || ""}
                      onChange={(val) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                description: val,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                    <div>
                      <TextField
                        sx={{ width: 300, mr: 3, mb: 1 }}
                        label="Action Button Text"
                        variant="outlined"
                        value={data[index]?.btnText || ""}
                        error={errors[index]?.error}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, btnText: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />

                      <TextField
                        sx={{ width: 300 }}
                        label="Action Button Link"
                        variant="outlined"
                        value={data[index]?.btnLink || ""}
                        error={errors[index]?.error}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, btnLink: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                    </div>
                  </div>

                  <div className="mt-5 grid grid-cols-1 ">
                    {[...Array(4)].map((_, idx) => (
                      <div key={idx} className="w-3/4 mt-4">
                        <h3>Card {idx + 1}</h3>
                        <TextField
                          sx={{ width: 300, mt: 1, mb: 2 }}
                          label="Title"
                          variant="outlined"
                          size="small"
                          value={data[index]?.cards[idx]?.title || ""}
                          onChange={(e) => {
                            setData((prevData) =>
                              prevData.map((item, i) => {
                                if (i === index) {
                                  return {
                                    ...item,
                                    cards: item.cards.map((card, j) => {
                                      if (j === idx) {
                                        return {
                                          ...card,
                                          title: e.target.value,
                                        };
                                      }
                                      return card;
                                    }),
                                  };
                                }
                                return item;
                              })
                            );
                          }}
                        />

                        <TextField
                          sx={{ width: 300, ml: 1, mt: 1, mb: 2 }}
                          label="Link"
                          variant="outlined"
                          size="small"
                          value={data[index]?.cards[idx]?.link || ""}
                          onChange={(e) => {
                            setData((prevData) =>
                              prevData.map((item, i) => {
                                if (i === index) {
                                  return {
                                    ...item,
                                    cards: item.cards.map((card, j) => {
                                      if (j === idx) {
                                        return {
                                          ...card,
                                          link: e.target.value,
                                        };
                                      }
                                      return card;
                                    }),
                                  };
                                }
                                return item;
                              })
                            );
                          }}
                        />

                        <TextEditor
                          value={data[index]?.cards[idx]?.subTitle || ""}
                          onChange={(val) => {
                            setData((prevData) =>
                              prevData.map((item, i) => {
                                if (i === index) {
                                  return {
                                    ...item,
                                    cards: item.cards.map((card, j) => {
                                      if (j === idx) {
                                        return {
                                          ...card,
                                          subTitle: val,
                                        };
                                      }
                                      return card;
                                    }),
                                  };
                                }
                                return item;
                              })
                            );
                          }}
                        />
                      </div>
                    ))}
                  </div>

                  {user.perms[7].edit && (
                    <div className="submitBTN" onClick={() => submitData(item, index)}>
                      Save Changes
                    </div>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
